export const eyeDisease = {
  uz: {
    eyeDiseaseTitle: "Ko'z Kassalliklari",
    eyeDiseaseAstigatismTitle: "Astigmatizm",
    eyeDiseaseAstigatismText:
      "Homiladorlik yoki muammolarni bartaraf etish yo'q. Oson tanishlar yo'q. Forex savdosi sohasida juda arzon martaba. Yengish uchun qulaylik",
    eyeDiseaseAstigatismList1: "Homiladorlik va sho'ng'in",
    eyeDiseaseAstigatismList2: "Oson tanishlar yo'q",
    eyeDiseaseAstigatismList3: "Yengish uchun qulaylik",
    eyeDiseaseGlaucomaTitle: "Glaukoma",
    eyeDiseaseGlaucomaText:
      "Shokolad har doim toza va erga uy vazifasi kerak. Endi men o'zim bilan kurashaman. Ba'zan bu tashqi nasos",
    eyeDiseaseGlaucomaList1: "Homiladorlik va sho'ng'in",
    eyeDiseaseGlaucomaList2: "Oson tanishlar yo'q",
    eyeDiseaseGlaucomaList3: "Yengish uchun qulaylik",
    eyeDiseaseDryEyeTitle: "Quruq ko'zlar",
    eyeDiseaseDryEyeText:
      "Homiladorlik yoki muammolarni bartaraf etish yo'q. Oson tanishlar yo'q. Forex bozorida juda arzon o'quv kursi",
    eyeDiseaseDryEyeList1: "Homiladorlik va sho'ng'in",
    eyeDiseaseDryEyeList2: "Oson tanishlar yo'q",
    eyeDiseaseDryEyeList3: "Yengish uchun qulaylik",
    eyeDiseaseCataractTitle: "Katarakt",
    eyeDiseaseCataractText:
      "Kulgi sizning xohishingizga qarab farq qilishi mumkin. Portfelda futbol maydonlarida kiyinishning ko'p qismini qilish imkoniyati yo'q edi",
    eyeDiseaseCataractList1: "Homiladorlik va sho'ng'in",
    eyeDiseaseCataractList2: "Oson tanishlar yo'q",
    eyeDiseaseCataractList3: "Yengish uchun qulaylik",
    eyeDiseaseGetConsultationBtnText: "Konsultatsiya olish",
  },
  ru: {
    eyeDiseaseTitle: "Глазные Болезни",
    eyeDiseaseAstigatismTitle: "Астигматизм",
    eyeDiseaseAstigatismText:
      "Никакой беременности или устранения неполадок. Легких знакомств не бывает. Очень недорогая карьера в сфере торговли на рынке Форекс. Комфорт, который нужно превзойти",
    eyeDiseaseAstigatismList1: "Беременность и дайвинг",
    eyeDiseaseAstigatismList2: "Легких знакомств не бывает",
    eyeDiseaseAstigatismList3: "Комфорт, который нужно превзойти",
    eyeDiseaseGlaucomaTitle: "Глаукома",
    eyeDiseaseGlaucomaText:
      "Шоколад всегда чистый, и на земле ему нужна домашняя работа. Теперь я борюсь с самим собой. Иногда это бывает уличный насос",
    eyeDiseaseGlaucomaList1: "Беременность и дайвинг",
    eyeDiseaseGlaucomaList2: "Легких знакомств не бывает",
    eyeDiseaseGlaucomaList3: "Комфорт, который нужно превзойти",
    eyeDiseaseDryEyeTitle: "Сухость глаз",
    eyeDiseaseDryEyeText:
      "Никакой беременности или устранения неполадок. Легких знакомств не бывает. Очень недорогой курс обучения на рынке форекс",
    eyeDiseaseDryEyeList1: "Беременность и дайвинг",
    eyeDiseaseDryEyeList2: "Легких знакомств не бывает",
    eyeDiseaseDryEyeList3: "Комфорт, который нужно превзойти",
    eyeDiseaseCataractTitle: "Катаракта",
    eyeDiseaseCataractText:
      "Смех может варьироваться в зависимости от вашего желания. В портфолио не было возможности сделать большую часть переодевания на футбольных полях",
    eyeDiseaseCataractList1: "Беременность и дайвинг",
    eyeDiseaseCataractList2: "Легких знакомств не бывает",
    eyeDiseaseCataractList3: "Комфорт, который нужно превзойти",
    eyeDiseaseGetConsultationBtnText: "Получить консультацию",
  },
  tj: {
    eyeDiseaseTitle: "Бемориҳои Чашм",
    eyeDiseaseAstigatismTitle: "Астигматизм",
    eyeDiseaseAstigatismText:
      "Ҳомиладорӣ е ҳалли мушкилот нест. Знакомств осон нест. Карераи хеле арзон дар савдои forex. Бароҳатӣ барои задан",
    eyeDiseaseAstigatismList1: "Ҳомиладорӣ ва ғаввосӣ",
    eyeDiseaseAstigatismList2: "Знакомств осон нест",
    eyeDiseaseAstigatismList3: "Бароҳатӣ барои задан",
    eyeDiseaseGlaucomaTitle: "Глаукома",
    eyeDiseaseGlaucomaText:
      "Шоколад ҳамеша тоза аст ва дар замин ба вазифаи хонагӣ ниез дорад. Ҳоло ман бо худам мубориза мебарам. Баъзан ин насоси берунӣ аст",
    eyeDiseaseGlaucomaList1: "Ҳомиладорӣ ва ғаввосӣ",
    eyeDiseaseGlaucomaList2: "Знакомств осон нест",
    eyeDiseaseGlaucomaList3: "Бароҳатӣ барои задан",
    eyeDiseaseDryEyeTitle: "Чашмони хушк",
    eyeDiseaseDryEyeText:
      "Ҳомиладорӣ е ҳалли мушкилот нест. Знакомств осон нест. Курси хеле арзон дар бозори forex",
    eyeDiseaseDryEyeList1: "Ҳомиладорӣ ва ғаввосӣ",
    eyeDiseaseDryEyeList2: "Знакомств осон нест",
    eyeDiseaseDryEyeList3: "Бароҳатӣ барои задан",
    eyeDiseaseCataractTitle: "Катаракта",
    eyeDiseaseCataractText:
      "Ханда метавонад вобаста ба хоҳиши шумо фарқ кунад. Дар портфолио имкони аксари либоспӯшӣ дар майдонҳои футбол вуҷуд надошт",
    eyeDiseaseCataractList1: "Ҳомиладорӣ ва ғаввосӣ",
    eyeDiseaseCataractList2: "Знакомств осон нест",
    eyeDiseaseCataractList3: "Бароҳатӣ барои задан",
    eyeDiseaseGetConsultationBtnText: "Машварат гиред",
  },
};
